export default __webpack_public_path__ + "static/media/twitter.cab83ccd.png";